/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * The bare mail address of a readable mail header, lowercased so it can be used as a lookup key.
 * @example `Max Mustermann <max.mustermann@mmmint.ai>` -> `max.mustermann@mmmint.ai`
 * @example `max.mustermann@mmmint.ai` -> `max.mustermann@mmmint.ai`
 * @param readable the from or to header as it is displayed
 * @returns the address, or an empty string when the header holds none
 */
export function mailAddress(readable?: string): string {
  if (!readable) {
    return "";
  }

  const bracketed = readable.match(/<([^>]+)>/);

  return (bracketed?.[1] ?? readable).trim().toLowerCase();
}

/**
 * Creates an avatar of the mail
 * @example `info@mmmint.ai` -> I
 * @example `max.mustermann@mmmint.ai` -> MM
 * @param mail the supposedly mail
 * @returns an avatar of the first letters of the mails local part
 */
export function avatar(mail: string): string {
  if (!mail) {
    return "";
  }

  const localPart = mail.split("@");
  if (!localPart) {
    return mail[0].toUpperCase();
  }

  const bits = localPart[0].split(".");

  if (!bits) {
    return "";
  }

  if (bits.length >= 1 && bits[1]) {
    return `${bits[0][0]}${bits[1][0]}`.toUpperCase();
  }

  return `${bits[0][0]}`.toUpperCase();
}
